import { isNotDefined } from '@sgme/fp';
import { Button, HStack } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { checkIfUserCanTrade, useUserContext } from '@/context/UserContext.tsx';
import type { Order } from '@/store/orders/state.ts';

type OrderFooter = {
  tile: Order | undefined;
  isModifyingField: boolean;
  handleSubmit: () => void;
};

export const OrderFooter = ({ tile, isModifyingField, handleSubmit }: OrderFooter) => {
  const userContextValue = useUserContext();
  const canTrade = checkIfUserCanTrade(userContextValue);

  const isDisabled = isNotDefined(tile) || !tile.properties.isReadyToSubmit || !canTrade || isModifyingField;

  return (
    <HStack horizontalAlignment="end" gap="8px" className="mx-16px">
      <Button purpose="primary" disabled={isDisabled} onClick={handleSubmit} data-e2e="place-order-button">
        <FormattedMessage id="order.footer.button.placeOrder" />
      </Button>
    </HStack>
  );
};
